import React from 'react'

import ObjectiveWarningMessage from '../../../../../Multiplatform/UploadAdCreative/ObjectiveWarningMessage'
import ErrorMessage from '../../../../../../components/Form/ErrorMessage'
import RemainingCampaignImpressionsBudgetFields from '../../../../../Multiplatform/UploadAdCreative/ImpressionsBudgetSection/RemainingCampaignImpressionsBudgetFields'
import ToggleField from '../../../../../../components/Form/ToggleField'
import CampaignObjectiveField from './CampaignObjectiveField'

import { getIsObjectiveEquivalentToReach } from '../../../../../Multiplatform/UploadAdCreative/helpers'

import { BUDGET_DAILY, OBJECTIVE } from '../../../../../Multiplatform/CampaignForms/fields'
import { REACH } from '../../../../../../constants/campaigns'

import { AUTO_OPTIMIZED_CAMPAIGN_BUDGET } from '../../../../../reusableFields'
import { BUDGET_OPTION } from '../../../../../Multiplatform/fields'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'
import useAutoOptimiseToggleLabelStyles from '../../../../../../styles/common/autoOptimiseToggleLabelStyles'

const NewCampaignImpressionsFields = ({ formik, remainingImpressions }) => {
  const drawerFormClasses = useDrawerFormStyles()
  const classes = useAutoOptimiseToggleLabelStyles()

  const { values, setFieldValue } = formik

  const showBudgetSection = values[OBJECTIVE] !== REACH

  const isObjectiveEquivalentToReach = getIsObjectiveEquivalentToReach(values[OBJECTIVE])

  if (remainingImpressions < 1) {
    return <ErrorMessage fontSize={14} error="Your remaining impressions are too low to create a campaign." />
  }

  return (
    <>
      <div className={drawerFormClasses.subSection}>
        <CampaignObjectiveField formik={formik} />
        {!isObjectiveEquivalentToReach && <ObjectiveWarningMessage />}
      </div>
      {showBudgetSection && (
        <div className={drawerFormClasses.subSection}>
          <ToggleField
            name={AUTO_OPTIMIZED_CAMPAIGN_BUDGET}
            isEnabled={values[AUTO_OPTIMIZED_CAMPAIGN_BUDGET]}
            setFieldValue={setFieldValue}
            label={'Auto optimised campaign budget'}
            labelClassName={classes.autoOptimiseToggleLabel}
            isSolid={false}
          />
          {values[AUTO_OPTIMIZED_CAMPAIGN_BUDGET] && (
            <>
              {/* Budget type selection is temporarily commented out, because for now we need only lifetime budget*/}
              {/*todo uncomment when needed*/}
              {/*<BudgetTypeField formik={formik} />*/}
              <RemainingCampaignImpressionsBudgetFields
                formik={formik}
                remainingImpressions={remainingImpressions}
                impressionsFieldPlaceholder={'Impressions budget'}
                isDailyBudget={values[BUDGET_OPTION] === BUDGET_DAILY}
              />
            </>
          )}
        </div>
      )}
    </>
  )
}

export default NewCampaignImpressionsFields
